import React from "react";
import CancelExchangeConfirm from "./lib/cancelExchangeConfirm";
import { CopyLinkButton } from "./lib/byttevagtPage";
/**
 * A shift of the volunteer's own that is on the exchange: the link to share and the way to take it
 * back, as one joined control - Kopiér link and a red Træk tilbage in a pink bar. The link itself is
 * not shown: it is only ever copied, and a link cut off to fit says nothing to anybody.
 */
export default class ShiftExchangeViewComponent extends React.Component {
    constructor(props) {
        super(props);
        /**
         * Opens the confirmation. Taking the byttevagt back used to happen on the click itself; it now asks
         * first, since it cannot be undone and lapses every other volunteer's offer on the byttevagt - and
         * when the shift is also in one of this volunteer's own offers, asks whether to withdraw it there too.
         */
        this.cancelExchange = () => this.setState({ confirmingCancel: true, error: null });
        this.state = {
            confirmingCancel: false,
            error: null
        };
    }
    render() {
        const se = this.props.shiftexchange;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "bi-xv" },
                React.createElement("div", { className: "bi-xseg" },
                    React.createElement(CopyLinkButton, { slug: se.slug, className: "bi-xseg-btn", icon: React.createElement("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.75", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" },
                            React.createElement("path", { d: "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" }),
                            React.createElement("path", { d: "M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" })) }),
                    React.createElement("button", { type: "button", className: "bi-xseg-btn bi-xseg-cancel", onClick: this.cancelExchange },
                        React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": "true" },
                            React.createElement("path", { d: "M6 6l12 12M18 6 6 18" })),
                        "Tr\u00E6k tilbage")),
                this.state.error
                    ? React.createElement("div", { className: "bi-bv-alert bi-bv-alert-error", role: "alert" }, this.state.error)
                    : null),
            this.state.confirmingCancel
                ? React.createElement(CancelExchangeConfirm, { shiftExchangeId: se.id, shiftMemberId: se.shiftMemberId, onCancelled: () => {
                        this.setState({ confirmingCancel: false });
                        this.props.oncancelled();
                    }, onClose: () => this.setState({ confirmingCancel: false }), onError: (message) => this.setState({ confirmingCancel: false, error: message }) })
                : null));
    }
}
